import React, { useMemo, useCallback } from "react";
import { Checkbox } from "antd";
import { UserType } from "@/utils/enum";

const PRIVACY_POLICY_URL = "https://www.autosled.com/privacy-policy/";
const TRANSPORTER_TERMS_URL = "https://autosled.com/carrier_terms_of_use/";
const DEALER_TERMS_URL = "https://autosled.com/shipper_terms_of_use/";

const Footer = ({ type, accepted, error, onChange: propOnChange }) => {
  const termsUrl = useMemo(() => {
    switch (type) {
      case UserType.Dealer:
        return DEALER_TERMS_URL;

      case UserType.Transporter:
        return TRANSPORTER_TERMS_URL;

      default:
        return "";
    }
  }, [type]);

  const onChange = useCallback(
    event => {
      if (typeof propOnChange === "function") {
        propOnChange(event.target.checked);
      }
    },
    [propOnChange],
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        margin: "0 16px 32px 16px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Checkbox style={{ fontSize: "18px", textAlign: "center" }} value={accepted} onChange={onChange}>
          I agree to the{" "}
          <a href={termsUrl} target="_blank" rel="noopener noreferrer">
            Terms and Conditions
          </a>{" "}
          and{" "}
          <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </Checkbox>
        {error && (
          <p style={{ marginLeft: "24px", color: "#dc3545" }} className="text-danger">
            You must agree to the terms and conditions to continue.
          </p>
        )}
      </div>
    </div>
  );
};

export default Footer;
